import { setUser } from '@sentry/react';
import Axios, { AxiosInstance } from 'axios';
import { makeObservable, observable, runInAction } from 'mobx';
import UserInfo from '../Models/UserInfo';

export default class GlobalStore {
    constructor() {
        this.axios = Axios.create({
            withCredentials: true
        });

        makeObservable(this, {
            initialised: observable,
            userInfo: observable,
            loggingIn: observable
        });
    }

    readonly axios: AxiosInstance;

    initialised = false;

    userInfo?: UserInfo;

    error?: Error;

    loggingIn = false;

    handleError = (error: Error) => runInAction(() => {
        this.error = error;
    });

    initialiseAsync = async () => {
        if (this.initialised) {
            return;
        }
        runInAction(() => {
            this.initialised = true;
        });
        runInAction(() => {
            this.loadUserInfo();
        });
    };

    loadUserInfo = () => {
        (async () => {
            // eslint-disable-next-line no-debugger
            const user = await this.axios.get<UserInfo>('/api/auth/user');
            runInAction(() => {
                this.userInfo = user.data;
            });
            setUser({
                id: user.data.studentId,
                username: `${user.data.firstName} ${user.data.lastName}`
            });
        })().catch(() => {
            window.location.href = `/api/auth/login?returnUrl=${window.location.href}`;
            runInAction(() => {
                this.loggingIn = true;
            });
        });
    };
}
